import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import styles from "./CarCard.module.scss";
import { Dictionary } from "util/Dictionary";
import AppState from "util/AppState";
import Server from "util/Server";
import { useAuth } from "util/auth";

function CarCard({carId}) {
  const router = useRouter();
  const auth = useAuth();
  const [car, setCar] = useState(null);
  const [updated, setUpdated] = useState(Date.now());

  const loadCar = async () => {
    if (carId) {
      try {
        const response = await Server().getCarById(carId);
        const { status, payload } = response;
        if (status.value === true) {
          setCar(payload);
        }
      } catch (e) {
        console.log('failure happened');
      }
    }
  }

  useEffect(() => {
    loadCar();
  }, [carId, updated])

  const handleStatusSwitch = (nextStatus) => {
    const data = {
      owner_phone_number: auth.user.phoneNumber,
      status: nextStatus
    };
    const token = auth.user.token;
    Server().updateCarAsync(`${Server.VEHICLE_URL}/${carId}`, data, token)
      .then(result => { 
        if (result.status.value) {
          setUpdated(Date.now());
        }
      });
  }

  // Render nothing if no car
  if (!car) {
    return null;
  }

  // parse props
  const {
    uuid,
    pictures,
    mark,
    model,
    year,
    reg_number,
    fuel,
    mileage,
    transmission,
    fuel_consumption,
    seats,
    car_type,
  } = car;

  return (
    <>
      <Card style={{ margin: "0 0 25px 0" }}>
        <div className="container" style={{ padding: "5px 5px 5px 10px" }}>
          <div className="row">
            <div className="col-sm-4">
              <Card.Img
                variant="top"
                style={{
                  marginRight: "20px",
                  marginTop: "20px",
                }}
                src={
                  (pictures ? pictures[0] : "") ||
                  "https://via.placeholder.com/130x100.png?text=Foto+nėra"
                }
              />
            </div>
            <div className="col-sm-8">
              <div className="row">
                <div className="col-sm" style={{ marginRight: "30px" }}>
                  <div className={styles.ItemGroup}>
                    <div className={styles.ItemGroupTitle}>Modelis:</div>
                    <div
                      className={styles.ItemGroupInfo}
                    >{`${mark} ${model}`}</div>
                  </div>
                  <div className={styles.ItemGroup}>
                    <div className={styles.ItemGroupTitle}>Gamybos metai:</div>
                    <div className={styles.ItemGroupInfo}>{year}</div>
                  </div>
                  <div className={styles.ItemGroup}>
                    <div className={styles.ItemGroupTitle}>Valst. Nr.: </div>
                    <div className={styles.ItemGroupInfo}>{reg_number}</div>
                  </div>
                  <div className={styles.ItemGroup}>
                    <div className={styles.ItemGroupTitle}>Kuro tipas: </div>
                    <div className={styles.ItemGroupInfo}>
                      {Dictionary.fuel[fuel][AppState.language]}
                    </div>
                  </div>
                  <div className={styles.ItemGroup}>
                    <div className={styles.ItemGroupTitle}>Odometro rodmuo: </div>
                    <div className={styles.ItemGroupInfo}>{mileage}</div>
                  </div>
                </div>
                <div className="col-sm">
                  <div className={styles.ItemGroup}>
                    <div className={styles.ItemGroupTitle}>Pavarų dėžė:</div>
                    <div className={styles.ItemGroupInfo}>
                      {
                        Dictionary.carTransmission[transmission][
                          AppState.language
                        ]
                      }
                    </div>
                  </div>
                  <div className={styles.ItemGroup}>
                    <div className={styles.ItemGroupTitle}>
                      Suvartojamo kuro kiekis (litrais):
                    </div>
                    <div className={styles.ItemGroupInfo}>{fuel_consumption}</div>
                  </div>
                  <div className={styles.ItemGroup}>
                    <div className={styles.ItemGroupTitle}>
                      Sėdimų vietų skaičius:
                    </div>
                    <div className={styles.ItemGroupInfo}>{seats}</div>
                  </div>
                  <div className={styles.ItemGroup}>
                    <div className={styles.ItemGroupTitle}>
                      Automobilio tipas:
                    </div>
                    <div className={styles.ItemGroupInfo}>
                      {Dictionary.carType[car_type][AppState.language]}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <Card.Body className="row">
            <Card.Link className="col-sm-auto mx-0 my-1" href={`/dashboard/car/${uuid}/edit-photos`}>
              Nuotrauka
            </Card.Link>
            <Card.Link className="col-sm-auto mx-0 my-1" href={`/dashboard/car/${uuid}/edit-pricing`}>
              Kainodara
            </Card.Link>
            <Card.Link className="col-sm-auto mx-0 my-1" href={`/dashboard/car/${uuid}/edit-car`}>
              Redaguoti automobilį
            </Card.Link>
            <Card.Link className="col-sm-auto mx-0 my-1" href={`/dashboard/my-cars`}>
              Automobilių sąrašas
            </Card.Link>
            {car.status === Server.carStatus.ACTIVE && (<Card.Link className="col-sm-auto mx-0 my-1 cursor-pointer" onClick={() => handleStatusSwitch(Server.carStatus.INACTIVE)}>
              Deaktyvuoti automobilį
            </Card.Link>)}
            {car.status === Server.carStatus.INACTIVE && (<Card.Link className="col-sm-auto mx-0 my-1 cursor-pointer" onClick={() => handleStatusSwitch(Server.carStatus.ACTIVE)}>
              Aktyvuoti automobilį
            </Card.Link>)}
          </Card.Body>
        </div>
      </Card>
    </>
  );
}

export default CarCard;
